import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  padding: 20px;
  display: grid;
  gap: 10px;
  justify-content: center;
  text-align: center;
  font-size: 30px;
`;
export const Home = styled.div`
  font-size: 20px;
`;
